import React from 'react'

function Iplog() {
  return (
    <div>Iplog</div>
  )
}

export default Iplog